<template>
  <div class='home'>
    <LevelList
      v-show='listView'
      @newLevel='onClickNewFromList'
      @editLevel='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <LevelForm
      v-show='formView'
      :level='level'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import LevelList from '@/components/level/LevelList.vue'
import LevelForm from '@/components/level/LevelForm.vue'

export default {
  name: 'Level',
  components: {
    LevelList,
    LevelForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      level: {
        id: null,
        name: null,
        promo_id: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.level = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.level = {
        id: null,
        name: null,
        promo_id: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.level = {
        id: null,
        name: null,
        promo_id: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getPromoList')
  }
}
</script>
